module.exports = __webpack_public_path__ + "static/media/photinus-logo-1.01c0b315.svg";